<template>
    <div class=" department" :style="mainContentViewHeight"
         v-loading="loading"
         element-loading-text="拼命加载中">
        <div class="department-box" :style="mainContentViewHeight" v-if="hasDepartment">
            <ul class="aside" :style="leftContentViewHeight">
                <li class="title">
                    <h3>
                        部门管理
                    </h3>
                </li>
                <li class="down">
                    <el-tree :data="departmentList" :props="defaultProps" @node-click="selectNode"></el-tree>
                </li>
            </ul>
            <el-card class="box-card main" style="padding-top: 10px;" :style="leftContentViewHeight">
                <el-form ref="dataForm"
                         label-width="160px" class="two-item-form detail-form">
                    <h3 class="form-header" id="basicInfo">
                        部门基本信息
                        <el-button  type="text"   class="pull-right text-button" @click="tabsCloseCurrent">返回</el-button>
                        <el-button type="text" @click="addRoot(orgId)"
                                   class="pull-right text-button">添加一级部门
                        </el-button>  </h3>
                    <el-divider></el-divider>
                    <div v-if="hasItemId" style="width: 100%;display: block;">
                        <el-form-item label="上级部门:" v-if="selectData.parentName" class="single-item">
                            <span>{{selectData.parentName}}</span>
                        </el-form-item>
                        <el-form-item label="部门序号:" class="single-item">
                            <span>{{selectData.sort}}</span>
                        </el-form-item>
                        <el-form-item label="部门名称:" class="single-item">
                            <span>{{selectData.deptName}}</span>
                        </el-form-item>
                        <el-form-item label="部门编号:" class="single-item">
                            <span>{{selectData.deptCode}}</span>
                        </el-form-item>
                        <el-form-item label="部门类型:" class="single-item">
                            <span>{{selectData.deptType}}</span>
                        </el-form-item>
                        <el-form-item label="部门简介:" class="single-item">
                            <span>{{selectData.description}}</span>
                        </el-form-item>
                        <el-form-item  class="single-item">
                            <el-button type="primary" v-if="hasItemId" @click="editHandler(orgId,itemid)">编辑
                            </el-button>
                            <el-button  v-if="hasItemId" @click="addDepartment(orgId,itemid)">添加子部门
                            </el-button>
                            <el-button v-if="hasItemId" @click="deleteHandler(orgId,itemid)">删除
                            </el-button>
                        </el-form-item>
                    </div>
                    <div v-if="!hasItemId" class="single-item">
                        <span>暂无数据</span>
                    </div>
                </el-form>
            </el-card>
        </div>
        <div class="department-box" :style="mainContentViewHeight" v-else>
            <el-card class="box-card main " :style="leftContentViewHeight">
               <div class="site-content">
                   <p class="not-found-desc">暂时不存在<em>部门</em>，请先 <el-button class="text-button text-button-larger" type="text" @click="addRoot(orgId)">添加部门
                   </el-button></p>
               </div>
            </el-card>
        </div>

        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="reloadData"></add-or-update>
    </div>
</template>
<script>
    import AddOrUpdate from './department_edit'

    export default {
        props: ['mainContentViewHeight'],
        name: "department",
        data() {
            return {
                loading: true,
                hasDepartment:true,
                departmentList: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                selectData: {},
                itemid: '',
                orgId: '',
                initial: '',
                show: false,
                addOrUpdateVisible: false,
            }
        },
        components: {
            AddOrUpdate
        },
        computed: {
            hasItemId: {
                get() {
                    return this.itemid != '' && this.itemid != undefined
                }
            },
            leftContentViewHeight: {
                get() {
                    return {height: this.mainContentViewHeight.minHeight}
                }
            },
        },
        methods: {
            reloadData() {
                this.getDepartment()
                this.loadDepartmentInfo(this.itemid)
            },
            getDepartment() {
                this.$http.get('/auth/department/sys_department_list?required=true&orgId=' + this.orgId).then(res => {
                    this.departmentList = res.data
                    if(res.data==undefined|| res.data.length==0){
                        this.hasDepartment=false
                    }else{
                        this.hasDepartment=true
                    }
                    this.loading=false
                }).catch(err => {
                    console.log(err)
                })
            },
            selectNode(data) {
                if (data.pId === undefined) {
                    this.initial = true;
                    this.itemid = data.id
                } else {
                    this.initial = false;
                    this.itemid = data.id
                }
                this.loadDepartmentInfo(this.itemid)
                this.show = true
            },
            loadDepartmentInfo(id){
                if(!id){
                    this.selectData = {}
                    return
                }
                this.$http({
                    url: '/auth/department/getDepartment?id=' + id,
                    method: 'post'
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.selectData = data.data
                    }else {
                        this.selectData = {}
                    }
                })
            },
            addDepartment(orgId) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(orgId, this.selectData,'')
                })
            },
            editHandler(orgId,id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(orgId, this.selectData,id)
                })
            },
            addRoot(orgId) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(orgId, {id:''},'')
                })
            },
            deleteHandler(orgId,id) {
                this.$confirm(`确定要删除该数据?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        url: this.$http.adornUrl('/auth/department/deleteDepartment?ids=' + id),
                        method: 'post',
                    }).then(({data}) => {
                        if (data && data.code === '1') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDepartment()
                                    this.selectData={}
                                    this.initial = false;
                                    this.itemid = ''
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {
                })
            }
        },
        created() {
            let orgId=this.$route.query.orgId
            if(orgId==undefined){
                orgId=this.$route.params.orgId
            }
            this.orgId=orgId 
            if(!this.orgId){
                this.$showErrorPage('组织机构信息无效')
                return
            }
            this.getDepartment();
        }
    }
</script>

<style lang="scss" scoped>
    .department {
        position: relative;

        .department-box {
            display: flex;
        }
    }

    .site-content {
        position: fixed;
        top: 25%;
        left: 50%;
        z-index: 2;
        padding: 30px;

        text-align: center;
        transform: translate(-50%, 0);
    }
    .not-found-title {
        margin: 20px 0 15px;
        font-size: 10em;
        font-weight: 400;
        color: rgb(55, 71, 79);
    }
    .text-button-larger{
        font-size: 26px;
        line-height: 26px;
        margin-top: 40px;
    }
    /*.not-found-desc {*/
    /*    margin: 0 0 30px;*/
    /*    font-size: 26px;*/
    /*    color: rgb(118, 131, 143);*/
    /*    > em {*/
    /*        font-style: normal;*/
    /*        color: #ee8145;*/
    /*    }*/
    /*}*/
    .department-box {
        .aside, .main {
            background-color: #fff;
        }

    }

    .text-button{
        margin-right: 10px;
    }
</style>
